var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"label"},[_vm._v("商品分类")]),_c('el-tree',{attrs:{"data":_vm.classifyData,"props":_vm.defaultProps,"default-expand-all":true,"expand-on-click-node":false},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }